export default __webpack_public_path__ + "static/media/simple1.30e65e03.png";